"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactHelmet = require("react-helmet");

var _CssBaseline = _interopRequireDefault(require("@material-ui/core/CssBaseline"));

var _Container = _interopRequireDefault(require("@material-ui/core/Container"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

// import MainNavigation from '../MainNavigation';
var _default = function _default(_ref) {
  var data = _ref.data,
      children = _ref.children,
      showNav = _ref.showNav,
      MainNavigation = _ref.MainNavigation,
      Helmet = _ref.Helmet,
      fixed = _ref.fixed,
      maxWidth = _ref.maxWidth,
      _ref$style = _ref.style,
      style = _ref$style === void 0 ? {
    paddingLeft: 0,
    paddingRight: 0
  } : _ref$style;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_CssBaseline["default"], null), !!Helmet && /*#__PURE__*/_react["default"].createElement(Helmet, null), /*#__PURE__*/_react["default"].createElement(_Container["default"], {
    style: style,
    fixed: !!fixed,
    maxWidth: !!maxWidth
  }, !showNav || !MainNavigation ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, children) : /*#__PURE__*/_react["default"].createElement(MainNavigation, {
    data: data
  }, children)));
};

exports["default"] = _default;